/**
 * Ferrari Owner Club Dubai — place l'image fixe à droite de la vidéo (desk),
 * empilée sous la vidéo (mobile).
 */
(function () {
  const VIDEO_HINT = /ferrari-owner-club-dubai\/video\.mp4/i;
  const IMAGE_SRC =
    "https://cdn.shopify.com/s/files/1/0646/8488/4152/files/ferrari-foc-dubai-side.jpg?v=1791822386";
  const IMAGE_ALT = "Paul McLine at Ferrari Owner Club Dubai";

  function findVideo() {
    const videos = document.querySelectorAll("article video, .rte video, .article video, video");
    for (const video of videos) {
      const src =
        video.getAttribute("src") ||
        video.querySelector("source")?.getAttribute("src") ||
        "";
      if (VIDEO_HINT.test(src)) return video;
    }
    return null;
  }

  function mount() {
    if (document.querySelector(".pmcline-foc-duo")) return;
    const video = findVideo();
    if (!video) return;

    const root = document.createElement("div");
    root.className = "pmcline-foc-duo";
    root.setAttribute("role", "region");
    root.setAttribute("aria-label", "Ferrari Owner Club Dubai media");

    const media = document.createElement("div");
    media.className = "pmcline-foc-duo__media";

    const videoFrame = document.createElement("div");
    videoFrame.className = "pmcline-foc-duo__frame";

    const imageFrame = document.createElement("div");
    imageFrame.className = "pmcline-foc-duo__frame";
    const img = document.createElement("img");
    img.src = IMAGE_SRC;
    img.alt = IMAGE_ALT;
    img.width = 800;
    img.height = 1067;
    img.loading = "eager";
    img.decoding = "async";
    imageFrame.appendChild(img);

    const parent = video.parentNode;
    parent.insertBefore(root, video);
    videoFrame.appendChild(video);
    video.removeAttribute("width");
    video.style.width = "";
    video.style.height = "";
    if (!video.getAttribute("poster")) video.setAttribute("poster", IMAGE_SRC);

    media.appendChild(videoFrame);
    media.appendChild(imageFrame);
    root.appendChild(media);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", mount);
  } else {
    mount();
  }
})();
